import patternImage from "../../src/asset/Pattern.png";

export default function About() {
  return (
    <section
      id="about"
      className="bg-gradient-to-b from-[#0a0015] via-[#250B69] to-[#0a0015] py-20 px-6"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              What is AstraMiner ?
            </h2>
            <p className="text-white/70 mb-4 leading-relaxed">
              <p className="text-white/70 mb-4 leading-relaxed">
                Gamified Proof of Work Simulation Tool – Your Blockchain
                Learning Journey Simplified
              </p>
              The gamified simulator creates a competitive learning environment
              for the learners where they learn how a blockchain works by
              performing all the tasks from creating cryptographic wallets,
              creating transaction requests, digitally signing the requests, and
              broadcasting transaction requests to the network.
            </p>
            <p className="text-white/70 mb-4 leading-relaxed">
              Learners can perform the tasks of verifying the digital signatures
              using cryptographic verification algorithms, validating the
              balances of the transaction request to deny any double-spending,
              and thereafter allowing legit transactions to be included in a
              block.
            </p>
          </div>

          <div className="relative h-96 flex items-center justify-center">
            <img src={patternImage} alt="AstraMiner" className="w-68 h-68 " />
          </div>
        </div>
      </div>
    </section>
  );
}
